import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import QuestionFormBase from '../../components/forms/QuestionFormBase';
import * as api from '../../api/questionApi';

const ReadingQuestionForm = () => {
  const { readingId, questionSetId, questionId } = useParams();
  const location = useLocation();
  const { passage, type, questionCount, startQuestionNumber = 1, answerOptions = [] } = location.state || {};

  return (
    <QuestionFormBase
      parentId={readingId}
      questionSetId={questionSetId}
      questionId={questionId}
      section={passage}
      sectionKey="passage"
      sectionLabel="Passage"
      initialType={type}
      questionCount={questionCount}
      startQuestionNumber={startQuestionNumber}
      basePath="/readings"
      api={api}
      answerOptions={answerOptions}
    />
  );
};

export default ReadingQuestionForm;
